import { createFileRoute, redirect } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import {
  channelsSearchSchema,
  socialConnectionsQueryOptions,
  SocialHubPage,
} from '@/features/social';

/**
 * One card per network. The API's OAuth callback lands here with `?connected=pinterest` or
 * `?error=`; that goes on to Pinterest's Connection page, where the person started.
 */
export const Route = createFileRoute('/_authed/_active/s/$storeId/social/')({
  validateSearch: channelsSearchSchema,
  beforeLoad: ({ context, params, search }) => {
    requirePermission(context.me, 'social.read');
    if (search.connected || search.error) {
      throw redirect({
        to: '/s/$storeId/social/pinterest/connection',
        params,
        search,
        replace: true,
      });
    }
  },
  loader: ({ context, params }) =>
    context.queryClient
      .query({ ...socialConnectionsQueryOptions(params.storeId), staleTime: 'static' })
      .catch(() => undefined),
  component: SocialHubPage,
});
